"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateTariffRequest = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const ChargePointIdentifier_1 = require("./decorators/ChargePointIdentifier");
const ChargePointTariff_1 = require("./decorators/ChargePointTariff");
class UpdateTariffRequest extends base_models_1.Serializable {
}
exports.UpdateTariffRequest = UpdateTariffRequest;
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, ChargePointIdentifier_1.ChargePointIdentifier)(),
    (0, base_models_1.Docs)({ example: 'NLESSE00000013', description: 'The charge point identifier' }),
    tslib_1.__metadata("design:type", String)
], UpdateTariffRequest.prototype, "chargePointId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, ChargePointTariff_1.ChargePointTariff)(),
    (0, base_models_1.Docs)({ example: 0.1, description: 'The new tariff' }),
    tslib_1.__metadata("design:type", Number)
], UpdateTariffRequest.prototype, "tariff", void 0);
